import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import UserMenu from "./UserMenu";
import NavigationDrawer from "./NavigationDrawer";
import CachedIcon from "@mui/icons-material/Cached";
import VerifiedIcon from "@mui/icons-material/Verified"; // 追加
import { auth, db } from "../api/firebase";
import { onSnapshot, doc } from "firebase/firestore";
import { Link } from "react-router-dom"; // RouterLink としてインポート
import CreateHederMenu from "./CreateHeaderMenu";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn"; // ← 追加

function ResponsiveAppBar() {
  const [user, setUser] = useState(null);
  const [showYaeMenu, setShowYaeMenu] = useState(false);

  useEffect(() => {
    const yaeFlagRef = doc(db, "flag2025", "showYaeMenu"); // 管理用のパス

    const unsubscribe = onSnapshot(yaeFlagRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setShowYaeMenu(data.enabled === true); // enabled フィールドが true なら表示
      } else {
        setShowYaeMenu(false); // ドキュメントが存在しない場合は非表示
      }
    });

    return () => unsubscribe(); // クリーンアップ
  }, []);

  useEffect(() => {
    if (auth.currentUser) {
      const uid = auth.currentUser.uid;
      const userRef = doc(db, "users", uid);
      const unsubscribe = onSnapshot(userRef, (doc) => {
        if (doc.exists()) {
          setUser(doc.data());
        } else {
          console.log("No such document!");
        }
      });

      return () => unsubscribe();
    } else {
      setUser(null);
    }
  }, []);

  const has2ndGeneration = user?.payments?.some((p) => p.paymentPhase === "2");

  const reload = () => {
    window.location.reload();
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar position="fixed" color="inherit">
        <Container maxWidth="lg">
          <Toolbar disableGutters>
            {/* <NavigationDrawer user={user} /> */}
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1 }}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Link to="/home" underline="none">
                MasterMind
              </Link>
            </Typography>
            {/* <CreateHederMenu
              text="再読込"
              icon={CachedIcon}
              onclick={reload}
              complete
            /> */}
            {/* <CreateHederMenu
              text="認証"
              icon={VerifiedIcon}
              onclick={() => (window.location.href = "/verifing")} // 認証画面への遷移
              complete
            /> */}

            {/* {!has2ndGeneration && ( */}
            {/* <CreateHederMenu
              text="お支払"
              icon={MonetizationOnIcon}
              onclick={() => (window.location.href = "/pay")} // 認証画面への遷移
              complete
            /> */}
            {/* )} */}
            {/* {has2ndGeneration && showYaeMenu && (
              <CreateHederMenu
                text="八重の誓い"
                icon={MonetizationOnIcon}
                onclick={() => (window.location.href = "/yae")}
                complete
              />
            )} */}

            <UserMenu />
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
}

export default ResponsiveAppBar;
